import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthenticationService } from '../services/service.index';

declare function init_plugins();

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styles: []
})
export class PagesComponent implements OnInit {

  isLogin: boolean = false;
  user: any = {};
  d: Date = new Date();
  year: number;
  loadAPI: Promise<any>;
  gestion: string = '';

  idleState = '';
  timedOut = false;
  
  constructor(private _router: Router, private idle: Idle, private _as: AuthenticationService) {    
    idle.setIdle(60);
    idle.setTimeout(3480);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    idle.onTimeout.subscribe(() => {      
      this.idleState = 'PASO EL TIEMPO';
      this.timedOut = true;          
      this._as.logout();
    });
    idle.watch();
  }

  ngOnInit() {
    init_plugins();

    this.year = this.d.getFullYear();
    if (localStorage.getItem('u') != null) {
      this.isLogin = true;
      this.user = JSON.parse(localStorage.getItem('u'));
      this.gestion = 'Gestión: ' + localStorage.getItem('g');
    }
    else {
      if (window.location.href.indexOf('auth') == -1) {
        this._router.navigate(['login']);
      }
    }
  }
}
